import * as React from "react";

function BullseyeArrowIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m366.4 213.5 45.8 7.6c2.5 11.3 3.8 22.9 3.8 34.9 0 88.4-71.6 160-160 160S96 344.4 96 256 167.6 96 256 96c11.1 0 23.6 1.32 34.9 3.81l7.6 45.79-4.9 4.9c-11.7-4.2-24.4-7.4-37.6-7.4-61.9 0-112 51-112 112 0 62.8 50.1 112.9 112 112.9s112-50.1 112-112.9c0-12.3-2.3-25-6.5-36.7l4.9-4.9zm131.3-42c8.4 25.6 14.3 54.9 14.3 84.5 0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0c29.6 0 58 5.024 84.5 14.27l-38.8 38.77c-15.6-3.3-30-5.04-45.7-5.04-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208c0-15.7-1.7-31-5.9-45.7l39.6-38.8zM272.1 272.1c-8.5 10.2-23.7 10.2-33.1 0-9.3-8.5-9.3-23.7 0-33.1l92.2-92.1-8.5-50.66c-1.7-10.19 1.6-20.58 8.9-27.88l51.2-51.2c7.3-8.125 21.9-5.3 26.2 5.37l23 56.57 57.5 23c10.6 5.2 12.6 18.9 5.3 27.1l-51.2 51.2c-7.3 7.3-17.7 9.7-27.8 8.9l-50.7-8.5-93 91.3z"
  }));
}

const ForwardRef = React.forwardRef(BullseyeArrowIcon);
export default ForwardRef;